import { render, staticRenderFns } from "./Transcript.vue?vue&type=template&id=3cefcd4c&scoped=true&"
import script from "./Transcript.vue?vue&type=script&lang=js&"
export * from "./Transcript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cefcd4c",
  null
  
)

export default component.exports